export default __webpack_public_path__ + "static/media/radio-checked.3b7f40cf.svg";